export function getOlFeatureId(feature) {
    const id = feature.getId();
    return id === undefined ? undefined : String(id);
}
